import { useLocaleState, useNotify } from "ra-core";

import { getSupabaseClient } from "../providers/supabase/supabase";

/** Langue du compte (multilingue, étape 1) : enregistrée dans la base par `set_locale`, suivie par l'interface,
 * le récapitulatif par e-mail et les exports. Le navigateur garde la dernière langue choisie pour le premier
 * affichage ; la langue du compte la remplace dès qu'elle est lue. */
export type AccountLocale = "fr" | "en";
export const ACCOUNT_LOCALES: AccountLocale[] = ["fr", "en"];

/** Langue à appliquer au chargement : celle du compte si elle est choisie et différente de l'affichage. */
export const localeToApply = (
  account: string | null | undefined,
  current: string,
): AccountLocale | null =>
  (account === "fr" || account === "en") && account !== current
    ? account
    : null;

/** Change la langue affichée et l'enregistre dans le compte. */
export const useChangeAccountLocale = () => {
  const [, setLocale] = useLocaleState();
  const notify = useNotify();
  return async (next: AccountLocale) => {
    setLocale(next);
    const { error } = await getSupabaseClient().rpc("set_locale", {
      value: next,
    });
    if (error) notify(error.message, { type: "error" });
  };
};
